import { NetworkCookie } from "../../../cookie/NetworkCookie";
import { EnvGlobalsHandler } from "../../EnvGlobalsHandler";
import { IEnvironmentGlobals } from "../../IEnvironmentGlobals";
import { BasicModel } from "../BasicModel";
import { info } from "../../../logging/info";

export class BasicSharedObject {
    protected networkCookie: NetworkCookie;

    constructor() {
        this.networkCookie = BasicModel.networkCookie;
        this.saveFileSize(this.env.gameFileSize);
    }

    /**
     * Read username.
     * @return
     */
    public /*final*/ readLoginDataUsername(): string {
        return this.networkCookie.username;
    }

    /**
     * Read email.
     * @return
     */
    public /*final*/ readLoginDataEmail(): string {
        return this.networkCookie.email;
    }

    /**
     * Read login token.
     * @return
     */
    public /*final*/ readLoginDataLoginToken(): string {
        return this.networkCookie.loginToken;
    }

    public readLoginDataLanguage(): string {
        return this.networkCookie.getAttributeAsString("language");
    }

    /**
     * Write username and loginToken.
     * @return
     */
    public saveLoginData(user: string, loginToken: string): void {
        this.networkCookie.saveLoginData(user, loginToken);
    }

    /**
     * Deletes username/loginToken
     */
    public deleteLoginData(): void {
        this.networkCookie.deleteLoginData();
    }

    public saveLanguageData(language: string): void {
        this.networkCookie.setAttribute("language", language);
    }

    public saveCountryData(country: string): void {
        this.networkCookie.country = country;
    }

    public savePlayerID(_playerID: number): void {
        this.networkCookie.setAttribute("playerID", _playerID);
    }

    public readSelectedServer(): string {
        return this.networkCookie.getAttributeAsString("selectedServer");
    }

    public saveSelectedServer(selectedServer: string): void {
        this.networkCookie.setAttribute("selectedServer", selectedServer);
    }

    public readSoundSettings(): string[] {
        let result = [];
        if (this.networkCookie.hasAttribute("soundSettings")) {
            let soundData = this.networkCookie.getAttribute("soundSettings");
            if (typeof soundData === "string") {
                try {
                    result = JSON.parse(soundData);
                } catch (e) {
                    result = [];
                }
            } else if (Array.isArray(soundData)) {
                result = soundData;
            }
        }
        return result;
    }

    public saveSoundSettings(soundSettings: any[]): void {
        this.networkCookie.setAttribute("soundSettings", soundSettings);
    }

    public readInstanceId(): number {
        return this.networkCookie.instanceId;
    }

    public get hasInstanceId(): boolean {
        return this.networkCookie.hasInstanceId;
    }

    public saveInstance(instanceId: number, zoneId: number): void {
        this.networkCookie.instanceId = instanceId;
        this.networkCookie.zoneId = zoneId.toString();
    }

    public saveFileSize(gameFileSize: string): void {
        this.networkCookie.setAttribute("fileSize", gameFileSize);
    }

    // ******************************* FIRST FRAME SIZE
    /**
     * saves the first frame size to cookie
     * @param firstFrameSizeInKB - size of the first frame in kb
     */
    public saveFirstFrameSize(firstFrameSizeInKB: number): void {
        info(" saving size of first frame to cookie:" + firstFrameSizeInKB + "KB.");
        this.networkCookie.setAttribute("firstFrameSizeInKB_" + this.readInstanceId(), firstFrameSizeInKB);
    }

    /**
     * reads and returns the first frame size, as saved to the local object
     * @return first frame size in KB
     */
    public readFirstFrameSize(): number {
        let firstFrameSize: number;
        if (this.networkCookie.hasAttribute("firstFrameSize") && this.networkCookie.getAttribute("firstFrameSize") != null) {
            firstFrameSize = this.networkCookie.getAttributeAsNumber("firstFrameSize");
        } else {
            firstFrameSize = -1;
        }

        info("first frame size as read from cookie:" + firstFrameSize + "KB");
        return firstFrameSize;
    }

    public readIsSocialNetwork(): boolean {
        if (this.networkCookie.hasAttribute("isSocialNetwork")) {
            return this.networkCookie.getAttributeAsBoolean("isSocialNetwork");
        }
        return false;
    }

    public saveIsSocialNetwork(flag: boolean): void {
        this.networkCookie.setAttribute("isSocialNetwork", flag);
    }

    protected get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }
}
